import './helpers/i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import App from './App';
import React from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initializeFromUrl } from './helpers/storage';

// Read settings from URL
initializeFromUrl();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
